module.exports = __webpack_public_path__ + "static/img/base_9.15580d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/base_9.png
// module id = cWcH
// module chunks = 1